<div mat-dialog-title>
    <div class="dialog-header-title">{{ 'DialogAddRights.Title' | translate }}</div>
</div>

<mat-dialog-content>
    <div class="content">
        @if (listRights.length > 0) {
            <div class="container">
                <h2>{{ 'DialogAddRights.TitleList' | translate }}</h2>

                <mat-form-field class="example-form-field">
                    <mat-label>{{ 'DialogAddRights.SearchLabel' | translate }}</mat-label>
                    <input matInput type="text" [(ngModel)]="searchValue" (ngModelChange)="search()" />
                    @if (searchValue) {
                        <button matSuffix mat-icon-button (click)="searchValue = ''; search()" class="accent-button">
                            <mat-icon>close</mat-icon>
                        </button>
                    } @else {
                        <mat-icon matSuffix class="primary-button">search</mat-icon>
                    }
                </mat-form-field>

                <div class="list-container">
                    <div
                        cdkDropList
                        #rightsList="cdkDropList"
                        [cdkDropListData]="rights"
                        [cdkDropListConnectedTo]="[selecetedRightsList]"
                        class="list"
                        (cdkDropListDropped)="drop($event)">
                        @for (right of rights; track right) {
                            <div class="box" cdkDrag>{{ right.display }}</div>
                        }
                    </div>
                </div>
            </div>

            <div class="list-actions">
                <button mat-icon-button (click)="selectAll()" matTooltip="{{ 'DialogAddRights.SelectAll' | translate }}">
                    <mat-icon>keyboard_double_arrow_right</mat-icon>
                </button>
                <button mat-icon-button (click)="disableAll()" matTooltip="{{ 'DialogAddRights.UnselectAll' | translate }}">
                    <mat-icon>keyboard_double_arrow_left</mat-icon>
                </button>
            </div>

            <div class="container select-container">
                <h2>{{ 'DialogAddRights.TitleItemsSelected' | translate }}</h2>

                <div class="list-container">
                    <div
                        cdkDropList
                        #selecetedRightsList="cdkDropList"
                        [cdkDropListData]="selectedRights"
                        [cdkDropListConnectedTo]="[rightsList]"
                        class="list"
                        (cdkDropListDropped)="drop($event)">
                        @for (right of selectedRights; track right) {
                            <div class="box" cdkDrag>{{ right.display }}</div>
                        }
                    </div>
                </div>
            </div>
        } @else {
            <div class="empty-message">{{ 'DialogAddRights.NotRights' | translate }}</div>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-stroked-button class="accent-button" (click)="close()">{{ 'DialogAddRights.CancelButton' | translate }}</button>
    <button mat-raised-button class="accent-button" (click)="save()">{{ 'DialogAddRights.ValidButton' | translate }}</button>
</mat-dialog-actions>
